export enum AppRoutes {
  YARD_LOCATIONS_PAGE = 'list-yard-location',
  TEMPLATES_PAGE = 'hostlerplans',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
}
